import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';
import { useHeaderVisibility } from '@/composables/useHeaderVisibility';

/**
 * Composable for Conversations Header component customisation
 * Returns header container background styling and title configuration
 */
export const useConversationsHeaderCustomisation = () => {
  const { getField, isVisible: customisationIsVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CONVERSATIONS_PAGE,
    sectionKey: PUI.CONVERSATIONS_SECTION_KEYS.HEADER_BACKGROUND,
    blockKey: PUI.CONVERSATIONS_BLOCK_KEYS.HEADER,
  });

  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);

  // uiConfig.header.show takes highest priority over brand customisation (mirrors pl-chat-sdk behaviour)
  const isVisible = useHeaderVisibility(customisationIsVisible);

  return {
    isVisible,
    backgroundColor,
  };
};

/**
 * Composable for Conversations Header Title customisation
 */
export const useConversationsHeaderTitleCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CONVERSATIONS_PAGE,
    sectionKey: PUI.CONVERSATIONS_SECTION_KEYS.HEADER_TITLE,
    blockKey: PUI.CONVERSATIONS_BLOCK_KEYS.HEADER,
  });

  const textContent = getField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);

  return {
    isVisible,
    textContent,
    textColor,
  };
};

/**
 * Generic composable for Nav Icon customisation
 * @param sectionKey - The section key for the nav icon (NAV_ICON_1 or NAV_ICON_2)
 */
const useConversationsNavIconCustomisation = (sectionKey: string) => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CONVERSATIONS_PAGE,
    sectionKey,
    blockKey: PUI.CONVERSATIONS_BLOCK_KEYS.HEADER,
  });

  const actionColor = getField(PUI.COMMON_FIELD_KEYS.ACTION_COLOR);

  return {
    isVisible,
    actionColor,
  };
};

/**
 * Composable for Nav Icon 1 customisation
 */
export const useConversationsNavIcon1Customisation = () => {
  return useConversationsNavIconCustomisation(PUI.CONVERSATIONS_SECTION_KEYS.NAV_ICON_1);
};

/**
 * Composable for Nav Icon 2 customisation
 */
export const useConversationsNavIcon2Customisation = () => {
  return useConversationsNavIconCustomisation(PUI.CONVERSATIONS_SECTION_KEYS.NAV_ICON_2);
};
